import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Header from "../../components/landingPage/Header";
import Footer from "../../components/landingPage/Footer";
import InputField from "../../components/b2b/InputField";
import {
  faAddressCard,
  faBuilding,
  faEnvelope,
  faPhone,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import { faUserGroup } from "@fortawesome/free-solid-svg-icons";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  companyName: "",
  contactNumber: "",
  address: "",
};

const MultiItinerary = () => {
  const dispatch = useDispatch();
  const [newUser, setnewUser] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setnewUser({ ...newUser, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newUser.firstName === "" ||
      newUser.lastName === "" ||
      newUser.email === "" ||
      newUser.contactNumber === "" ||
      newUser.message === ""
    ) {
      toast.error("Please fill all the fields");
    } else {
      dispatch({ type: "REGISTER_MAIL", payload: newUser });
      setnewUser({
        firstName: "",
        lastName: "",
        email: "",
        contactNumber: "",
        message: "",
      });
    }
  };
  return (
    <>
      <div>
        <Header className="static" />
        <div className="relative">
          <img
            src={require("../../assets/images/login_landing.jpg")}
            alt=""
            className="hidden sm:block sm:h-[50rem] md:h-[51rem] lg:h-[50rem] xl:h-[51rem] w-screen object-cover"
          />

          {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}
          <div className="bg-black sm:transparent sm:hidden w-screen h-[45rem] object-cover"></div>
          {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}

          <div className="bg-gradient-to-r from-[#121518] to-[#322d2d] w-full h-full opacity-80 absolute top-0"></div>

          <div className="w-full absolute top-10">
            <div className="px-5 md:px-10 lg:px-44 xl:px-72 2xl:px-[30rem] text-left my-10 sm:my-16">
              <div className="bg-black rounded-lg p-6 sm:p-16 opacity-80 shadow-md">
                <h2 className="text-2xl sm:text-4xl text-center text-slate-300">
                  Have Multi-City Itinerary?
                </h2>
                {/* <div className='bg-white border border-slate-200 p-16 shadow-md rounded-xl w-3/4'> */}
                <div className="w-full mt-10">
                  <h2 className="text-md sm:text-lg font-medium text-slate-300">
                    Please give us your details or call us!
                  </h2>
                  <div className="sm:flex sm:space-x-5 mt-3 sm:mt-0">
                    <div className="border-slate-400 border rounded-md mt-3 w-full">
                      <InputField
                        isFontawesome={true}
                        fontawesomeIcon={faUser}
                        placeholder="First name"
                        id="firstName"
                        name="firstName"
                        type="text"
                        value={newUser.firstName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="border-slate-400 border rounded-md mt-3 w-full">
                      <InputField
                        isFontawesome={true}
                        fontawesomeIcon={faUser}
                        placeholder="Last name"
                        id="lastName"
                        name="lastName"
                        type="text"
                        value={newUser.lastName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="sm:flex sm:space-x-5 mt-3 sm:mt-0">
                    <div className="border-slate-400 border rounded-md mt-3 w-full">
                      <InputField
                        isFontawesome={true}
                        fontawesomeIcon={faPhone}
                        placeholder="Contact Number"
                        id="contactNumber"
                        name="contactNumber"
                        type="number"
                        value={newUser.contactNumber}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="border-slate-400 border rounded-md mt-3 w-full">
                      <InputField
                        isFontawesome={true}
                        fontawesomeIcon={faUserGroup}
                        placeholder="Number of Pax"
                        id="numberOfPax"
                        name="numberOfPax"
                        type="text"
                        value={newUser.numberOfPax}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="border-slate-400 border rounded-md mt-3 w-full">
                    <InputField
                      isFontawesome={true}
                      fontawesomeIcon={faEnvelope}
                      placeholder="Email Address"
                      id="email"
                      name="email"
                      type="text"
                      value={newUser.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="border-slate-400 border rounded-md mt-3 w-full">
                    <InputField
                      isFontawesome={true}
                      fontawesomeIcon={faAddressCard}
                      placeholder="Please share your complete requirement here.."
                      id="message"
                      name="message"
                      type="textarea"
                      value={newUser.message}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="text-center mt-5">
                    <button className="bg-[#fb4156] text-white w-full py-3 rounded-md">
                      SUBMIT
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default MultiItinerary;
